import type { Viewport } from '../types/viewport.type';

export const isViewportContained = (
  current: Viewport,
  container: Viewport,
): boolean => {
  const [curMinLon, curMinLat, curMaxLon, curMaxLat] = current;
  const [refMinLon, refMinLat, refMaxLon, refMaxLat] = container;

  return (
    curMinLon >= refMinLon &&
    curMinLat >= refMinLat &&
    curMaxLon <= refMaxLon &&
    curMaxLat <= refMaxLat
  );
};
